import React from "react";
import { ButtonComp, CardComp } from "../../../../components";
import FallbackImage from "../../../../components/Common/ImageWrapper";

export default function PrefixEmptyState({ onSetPrefix }) {
  return (
    <div className="w-full py-5">
      <div className="text-center mb-4">
        <FallbackImage src="/Icon/empty.png" width={120} height={120} />
        <h4 className="text-black1 fw-bold mt-3 mb-2">No Prefix Configured</h4>
        <p className="text-muted">
          Configure how membership numbers will be generated for your branch
        </p>
      </div>

      <div className="row g-4 mb-4">
        {/* Prefix Name Card */}
        <div className="col-12 col-md-4">
          <CardComp cardClassName="h-100">
            <div className="p-3">
              <h5 className="fw-bold text-black1 mb-3">
                <span className="text-primary1">1.</span> Prefix Name
              </h5>
              <p className="text-blacklight small mb-2">
                The constant text that appears before the numbers in membership IDs.
              </p>
              <div className="bg-light p-3 rounded">
                <p className="mb-1 small fw-bold">Example:</p>
                <p className="mb-0 small text-muted">
                  If prefix is <strong>"unique"</strong>
                </p>
                <p className="mb-0 small text-muted">
                  Membership numbers: <strong>unique-0001</strong>, <strong>unique-0002</strong>
                </p>
              </div>
            </div>
          </CardComp>
        </div>

        {/* Numeric Count Card */}
        <div className="col-12 col-md-4">
          <CardComp cardClassName="h-100">
            <div className="p-3">
              <h5 className="fw-bold text-black1 mb-3">
                <span className="text-primary1">2.</span> Numeric Count
              </h5>
              <p className="text-blacklight small mb-2">
                Number of digits after the prefix (determines padding).
              </p>
              <div className="bg-light p-3 rounded">
                <p className="mb-1 small fw-bold">Example:</p>
                <p className="mb-0 small text-muted">
                  Count of <strong>4</strong> = 4-digit numbers
                </p>
                <p className="mb-0 small text-muted">
                  Results: <strong>0001</strong>, <strong>0002</strong>, <strong>0010</strong>
                </p>
              </div>
            </div>
          </CardComp>
        </div>

        {/* Auto Generate Card */}
        <div className="col-12 col-md-4">
          <CardComp cardClassName="h-100">
            <div className="p-3">
              <h5 className="fw-bold text-black1 mb-3">
                <span className="text-primary1">3.</span> Auto Generate
              </h5>
              <p className="text-blacklight small mb-2">
                Determines how the numeric part is generated.
              </p>
              <div className="bg-light p-3 rounded">
                <p className="mb-1 small fw-bold">OFF (Sequential):</p>
                <p className="mb-2 small text-muted">
                  <strong>unique-0001</strong>, <strong>unique-0002</strong>, <strong>unique-0003</strong>
                </p>
                <p className="mb-1 small fw-bold">ON (Random):</p>
                <p className="mb-0 small text-muted">
                  <strong>unique-5785</strong>, <strong>unique-8564</strong>, <strong>unique-1234</strong>
                </p>
              </div>
            </div>
          </CardComp>
        </div>
      </div>

      {/* Note */}
      <div className="alert alert-info mb-4" style={{ backgroundColor: "#eaf1f4", borderColor: "var(--color-secondary)", color: "#425466" }}>
        <p className="mb-0 small">
          <strong>Note:</strong> If no prefix is set, membership numbers will be automatically generated as unique 8-digit numbers (e.g., 12345678).
        </p>
      </div>

      {/* Set Prefix Button */}
      <div className="text-center">
        <ButtonComp
          btnText="Set Prefix"
          onClick={onSetPrefix}
          btnClassName="bg-primary1 py-2 px-5 rounded text-white border-0"
        />
      </div>
    </div>
  );
}
